export interface TaskData {
  id: number;
  title?: string;
  template?: string;
  isSelected: boolean;
  iconUrl: string;
}

export interface QuestData {
  id: number;
  title: string;
  description: string;
  iconUrl: string;
  descriptionAudio?: string;
  template?: string;
  tasks: TaskData[];
}

export const QUEST_STRINGS = {
  newQuestText: "A new quest awaits!",
  letsGo: "Let's go!",
  woohoo: "Woohoo! You did a great job!",
  selectAtLeast: "Please select atleast 4 options.",
} as const;
